import React from 'react';

export type RoutingFiltersWarningContextValue = Readonly<{
  // Domain names that should render the "missing domain-wide Allow rule" warning
  // badge. Computed once from the full filter list so each row can decide from
  // its own domain, behaving identically in every view (flat, domain, pool,
  // permission) and staying correct as filters are added, edited, or deleted.
  warnedDomains: ReadonlySet<string>;
}>;

// Defaults to an empty set so a row rendered without a provider simply shows no
// warning (safe default for a purely informational badge).
export const RoutingFiltersWarningContext = React.createContext<RoutingFiltersWarningContextValue>({
  warnedDomains: new Set<string>(),
});

export function useRoutingFiltersWarning(): RoutingFiltersWarningContextValue {
  return React.useContext(RoutingFiltersWarningContext);
}
